import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'

type DailyBonusSeparatorProps = {
  day: number
} & React.CSSProperties

export const DailyBonusSeparator = (props: DailyBonusSeparatorProps) => {
  const { day, ...styles } = props
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.dailyBonus
  const { classes } = useStyles()
  return (
    <div
      className={classes.separatorWrapper}
      style={styles}
    >
      <div className={classes.separatorLine}></div>
      <div className={classes.daysLabel}>
        <span>
          {day} {texts.day}
        </span>
      </div>
      <div className={classes.separatorLine}></div>
    </div>
  )
}
